function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowHdct16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  "data-name": "Rectangle 1701",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m228.271 31.043 5 5 5-5",
  "data-name": "Path 685",
  style: {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(-225.271 -25.543)"
}));
export default SvgIconArrowHdct16;